import ConverterClass from '../../utils/converter';

class Converter extends ConverterClass {
    toClient(data = {}) { // eslint-disable-line
        return data;
    }
}

export default new Converter();